<template>
  <HomePageToggle v-if="currentUser && currentUser.id" />
</template>

<script>
import { mapState } from 'vuex'
import HomePageToggle from '@/components-v2/home/HomePage.toggle.vue'

export default {
  components: {
    HomePageToggle,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
}
</script>
